export { TimepickerConfig } from './timepicker.config';
export { TimepickerComponent } from './timepicker.component';
export { TimepickerModule } from './timepicker.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/ngx-bootstrap/timepicker/index.js
// module id = ../../../../ngx-bootstrap/timepicker/index.js
// module chunks = 8